import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';
import VideoBox from '../../../common/custom/VideoBox';

const QuestionnaireSurvey = () => {
    return (
      <>
        <h5>
          <b>Questionnaire/Survey</b>
        </h5>
        <p>
          Questionnaire Survey Form plugin allows users to create their own dynamic forms, add
          questions as they want and then publish those forms for their end users to answer those
          questions.
        </p>
        <DocsLink link="https://academy.drapcode.com/docs/app-plugin/questionnaire-survey-plugin" />
        <br />
        <h5>
          <b> Videos</b>
        </h5>
        <VideoBox
          heading="Questionnaire Survey Form Plugin View Video"
          imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Questionnaire+Survey+Form+Plugin.jpg"
          videoLink="https://www.youtube.com/watch?v=EBBBRLv-9WI"
        />
      </>
    );
};

export default QuestionnaireSurvey;
